import * as React from "react"
import IconSkeleton from "./IconSkeleton"
import { IconProps } from "./types"

export default function DefaultSpeedIcon(props: IconProps) {
  return (
    <IconSkeleton
      {...props}
      iconName="DefaultSpeedIcon"
      applyColorToStroke={false}
    >
      <path
        d="M20.9413 18.1969C20.5992 18.9171 19.8731 19.376 19.0758 19.376H5.63673C4.83944 19.376 4.11336 18.9171 3.77125 18.1969C3.1837 16.9601 2.85596 15.5776 2.85596 14.1243C2.85596 13.6106 2.89673 13.1064 2.97521 12.6148L4.92499 13.886C4.92249 13.9651 4.92124 14.0446 4.92124 14.1243C4.92124 15.2646 5.17795 16.345 5.63673 17.3107H19.0758C19.5346 16.345 19.7913 15.2646 19.7913 14.1243C19.7913 10.018 16.4625 6.68928 12.3563 6.68928C10.1194 6.68928 8.11333 7.67704 6.75033 9.24017L4.17636 9.2897C5.83069 6.49669 8.87478 4.62399 12.3563 4.62399C17.6031 4.62399 21.8566 8.87742 21.8566 14.1243C21.8566 15.5776 21.5288 16.9601 20.9413 18.1969ZM13.6402 12.8849C13.6714 13.122 13.6555 13.363 13.5934 13.5941C13.5317 13.8252 13.4249 14.0418 13.2794 14.2317C13.1338 14.4215 12.9522 14.5808 12.7451 14.7004C12.5379 14.82 12.3092 14.8976 12.072 14.9287C11.8348 14.9599 11.5938 14.944 11.3628 14.8819L3.03782 10.7657L12.3056 11.3634C12.5367 11.4252 12.7533 11.5319 12.9432 11.6775C13.133 11.8231 13.2922 12.0046 13.4119 12.2118C13.5315 12.419 13.6091 12.6477 13.6402 12.8849Z"
        fill="currentColor"
      />
    </IconSkeleton>
  )
}
